import { render, staticRenderFns } from "./App.vue?vue&type=template&id=050907a0&"
import script from "./app.js?vue&type=script&lang=js&"
export * from "./app.js?vue&type=script&lang=js&"
import style0 from "./assets/css/materialdesignicons.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./assets/sass/style.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports